




import { Component, Mixins } from "vue-property-decorator";
import { InjectedObjectEvidenceTextPresentableMixin } from "./mixins";

@Component
export default class InjectedObjectEvidenceTextContentDrawer extends Mixins(InjectedObjectEvidenceTextPresentableMixin) {}
